// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".CkMav{margin:0 0 24px;font-family:\"Merriweather\",serif;font-size:28px;font-weight:700;line-height:32px}@media screen and (min-width:768px){.CkMav{margin:0 0 40px;font-size:36px;line-height:44px}}.MCSsS{display:flex;flex-direction:column;grid-gap:16px;gap:16px}@media screen and (min-width:768px){.MCSsS{grid-gap:24px;gap:24px}}.tdf6U{margin:0;font-family:\"Merriweather\",serif;font-size:26px;font-weight:700;line-height:32px}@media screen and (min-width:768px){.tdf6U{font-size:30px;line-height:38px}}.SKQUH,.pmIsi{margin:0;font-size:16px;line-height:25px}@media screen and (min-width:768px){.SKQUH,.pmIsi{font-size:18px;line-height:30px}}.D3Nit{padding:0;margin:0;list-style-position:inside}.SLLfc{align-self:baseline}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"headerTitle": "CkMav",
	"main": "MCSsS",
	"mainTitle": "tdf6U",
	"listItem": "SKQUH",
	"mainText": "pmIsi",
	"list": "D3Nit",
	"mainButton": "SLLfc"
};
module.exports = ___CSS_LOADER_EXPORT___;
